import { MouseEvent } from 'react';

/**
 * Whether a click asks for a new browser tab: Ctrl (Windows), ⌘ (Mac), Shift
 * or the middle button — what every browser does with a link (GF 27.10.2026,
 * #2327).
 */
export const paloWantsNewTab = (event: Pick<MouseEvent, 'ctrlKey' | 'metaKey' | 'shiftKey' | 'button'>): boolean =>
    event.ctrlKey || event.metaKey || event.shiftKey || 1 === event.button;

/** For what cannot be a link, a table row say: the target in a tab of its own. */
export const paloOpenInNewTab = (href: string): void => {
    window.open(href, '_blank', 'noopener');
};

/**
 * Makes an element a real link that still moves within the app on a plain
 * click. Everything else — Ctrl/⌘ or the middle button, right-click and "open
 * in new tab" — the browser does itself, because there is a href to do it with.
 */
export const paloLinkProps = (
    href: string,
    onNavigate?: (to: string) => void
): { component: 'a'; href: string; onClick: (event: MouseEvent) => void } => ({
    component: 'a',
    href,
    onClick: event => {
        if (!onNavigate || paloWantsNewTab(event)) {
            return;
        }

        event.preventDefault();
        onNavigate(href);
    },
});

/** What an anchor brings along and a menu entry must not show. */
export const paloLinkReset = { color: 'inherit', textDecoration: 'none' } as const;
